import React, { Fragment, useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { stateAbbreviations, formatDate } from '../../../common/utils';
import { toast } from 'react-toastify';
import html2pdf from 'html2pdf.js';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { createFile } from '../../../common/api';
import { storeMedia, createId } from '../../../common/utils';


const PA = ( { close, user, aid, cid, lid, contacts, loans } ) => {
    const [ forOffer, setForOffer ] = useState( false );
    const [ name, setName ] = useState( '' );
    const [ offerDate, setOfferDate ] = useState();
    const [ status, setStatus ] = useState( '' );
    const [ ready, setReady ] = useState( false );
    const [ addr, setAddr ] = useState( 'TBD' );
    const [ city, setCity ] = useState( '' );
    const [ state, setState ] = useState( '' );
    const [ zip, setZip ] = useState( '' );
    const [ price, setPrice ] = useState( 0 );
    const [ maxPrice, setMaxPrice ] = useState( 0 );
    const [ offerType, setOfferType ] = useState( 'purchase' );
    const [ processing, setProcessing ] = useState( false );
    const [ paTmpl, setPaTmpl ] = useState( {} );

    
    const render = useCallback( ( content ) => {
        const t = Handlebars.compile( content );
        let params = {};

        Handlebars.registerHelper( 'isYes', function ( value ) {
            return ( value === 'Yes' );
        } );
        Handlebars.registerHelper( 'isRefi', function ( value ) {
            return value.match( /refi/i );
        } );
        Handlebars.registerHelper( 'textMatch', function ( a, b ) {
            return ( a === b );
        } );
        Handlebars.registerHelper( 'textMismatch', function ( a, b ) {
            return ( a !== b );
        } );
        Handlebars.registerHelper( 'formatMoney', function ( value ) {
            if ( !value ) {
                return '';
            }
            const sanitizedInput = ( typeof( value ) === 'string' ) ? value.replace( /[\$,]/g, '' ) : value;
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input has decimal places
            const hasDecimals = ( val % 1 ) !== 0;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: hasDecimals ? 2 : 0,
                maximumFractionDigits: hasDecimals ? 2 : 0,
            } );

            return formatter.format( val );
        } );
        Handlebars.registerHelper( 'formatPercentage', function ( value ) {
            if ( !value ) {
                return '';
            }
            const sanitizedInput = ( typeof( value ) === 'string' ) ? value.replace(/%/g, '') : value;
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input is already a percentage (i.e., it's greater than 1)
            const isDecimal = Math.abs( val ) <= 1;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'percent',
                minimumFractionDigits: 0, // isDecimal ? 3 : 3,
                maximumFractionDigits: 3 // isDecimal ? 3 : 3,
            } );

            return formatter.format( isDecimal ? val : val / 100 );
        } );
        
        const c = contacts[cid];
        const l = loans[lid];

        params['contact'] = {
            ...c,
            referredBy: contacts[c.referredById]
        };

        params['loan'] = {
            ...l,
            paPurchasePrice: price,
            subjectAddress: addr
        };
        
        return t( { 
            ...params,
            user: user
        } );
    }, [ user, contacts, loans, cid, lid, addr, price ] );
    
    const create = async () => {
        setProcessing( true );

        const pa = {
            name: name,
            subjectAddress: addr,
            price: price,
        };

        if ( forOffer ) {
            pa['offerDate'] = offerDate;
            pa['status:'] = status;
            pa['subjectCity'] = city;
            pa['subjectState'] = state;
            pa['subjectZip'] = zip;
        }

        console.log( 'pre-approval: ', pa );
        
        const opts = {
            filename: name,
            html2canvas: { scale: 3, allowTaint: true, useCORS: true, dpi: 300 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait', hotfixes: [ 'px_scaling' ] }
        }
        const body = render( paTmpl.body );
        const pdfBlob = await html2pdf().set( opts ).from( body ).toPdf().output( 'blob' );

        const n = createId( 'file' ) + '.pdf';
        await storeMedia( aid, user.email, n, pdfBlob, 'application/pdf' );
                
        let file = {
            mediaUrl: n,
            name: name,
            cid: cid,
            lid: lid
        }
        await createFile( aid, user.email, file );

        toast.success( `Successfully uploaded ${name}`, { theme: 'dark' } );
        console.log( 'uploaded: ', name );
        await html2pdf().set( opts ).from( body ).save();
        close();
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        const today = new Date();
        setOfferDate( formatDate( today ) );
    }, [] );

    useEffect( () => {
        if ( user && user.meta && user.meta.templates ) {
            setPaTmpl( user.meta.templates.find( f => f.objects.includes( 'portal' ) ) );
        }
    }, [ user ] );

    useEffect( () => {
        const c = contacts[cid];
        const street = ( addr ) ? addr.replace( /\s+/g, '' ) : 'TBD';
        const genDate = formatDate( new Date() );
        if ( c ) {
            setName( `${c.lastname}_PreApproval-${street}_${genDate}.pdf` );
        }
    }, [ contacts, cid, addr ] );

    useEffect( () => {
        if ( price ) {
            setReady( true );
        }
    }, [ price ] );

    useEffect( () => {
        if ( lid ) {
            const l = loans[lid];
            if ( l && l.paMaxPurchPrice ) {
                setPrice( l.paMaxPurchPrice );
                setMaxPrice( l.paMaxPurchPrice );
            } else {
                setMaxPrice( 999999999 );
            }
        } else {
            setMaxPrice( 999999999 );
        }
    }, [ lid, loans ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New Pre-Approval Letter</Col>
                </Row>
                <Container fluid>
                    <Row className='py-2'>
                        <Col>
                            <Form.Group>
                                <Form.Label>Is this for a specific offer?</Form.Label>
                                <Row>
                                    <Col xs='auto'><Form.Check
                                        inline
                                        label="Yes, an offer"
                                        name='role'
                                        type='radio'
                                        id='offer'
                                        onChange={ ( e ) => setForOffer( true ) }
                                    /></Col>
                                    <Col xs='auto'><Form.Check
                                        inline
                                        label='No, just a general letter'
                                        name='role'
                                        type='radio'
                                        id='tbd'
                                        defaultChecked
                                        onChange={ ( e ) => setForOffer( false ) }
                                    /></Col>
                                </Row>
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        ( forOffer ) ? (
                            <Fragment>
                                <Row className='pt-3 pb-2'>
                                    <Col xs='auto'>
                                        <Form.Group>
                                            <Form.Label>Offer Date</Form.Label>
                                            <Form.Control className='tf-modal-text-input' type='date' id='offerDate' value={offerDate} onChange={ ( e ) => setOfferDate( e.target.value ) } />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='py-2'>
                                    <Col xs='auto'>
                                        <Form.Group>
                                            <Form.Label>Current Status</Form.Label>
                                            <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                                {
                                                    [ 'Considering', 'Submitted' ].map( ( p, idx ) => <option key={idx} value={p}>{p}</option>)
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='py-2'>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Street</Form.Label>
                                            <Form.Control className='tf-modal-text-input' type='text' id='addr-street' value={addr} onChange={ ( e ) => setAddr( e.target.value ) } />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='py-2'>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>City</Form.Label>
                                            <Form.Control className='tf-modal-text-input' type='text' id='addr-city' value={city} onChange={ ( e ) => setCity( e.target.value ) } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs='auto'>
                                        <Form.Group>
                                            <Form.Label>State</Form.Label>
                                            <Form.Select size='sm' className='tf-modal-text-input' value={state} onChange={ ( e ) => setState( e.target.value ) }>
                                                {
                                                    stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col style={ { maxWidth: '100px' } }>
                                        <Form.Group>
                                            <Form.Label>Zip</Form.Label>
                                            <Form.Control className='tf-modal-text-input' type='text' id='addr-zip' value={zip} onChange={ ( e ) => setZip( e.target.value ) } />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Fragment>
                        ) : (
                            null
                        )
                    }
                    <Row className='py-2'>
                        <Col xs='auto'>
                            <Form.Group>
                                <Form.Label>Purchase Price</Form.Label>
                                <Form.Control className='tf-modal-text-input' type='number' id='price' value={price} min="0" max={maxPrice} onChange={ ( e ) => setPrice( e.target.value ) } />
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* <Row className='py-2'>
                        <Col xs='auto'>
                            <Form.Group>
                                <Form.Label>Loan Amount</Form.Label>
                                <Form.Control className='tf-modal-text-input' type='text' id='loan' value={loan} onChange={ ( e ) => setLoan( e.target.value ) } />
                            </Form.Group>
                        </Col>
                    </Row> */}
                    <Row className='py-2'>
                        <Col xs='auto'>
                            <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                        </Col>
                        <Col xs='auto'>
                            <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                        </Col>
                    </Row>
                </Container>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( PA );